import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Row, Col, ProgressBar } from "react-bootstrap";
import Breadcrumbs from "../../components/breadcrumbs";
import { shallowEqual, useSelector } from "react-redux";
import Arrow from "../../components/navigation/progress/svg/Arrow";
import axios from "axios";
import styled from "styled-components";
import useCurrentLocation from "../../hooks/useCurrentLocation";

const ConstructorPage = () => {
  const isRequestUpdateTimeProgress = useRef(false);
  const [isPageEdited, setIsPageEdited] = useState(false);

  const { entryLocationEdit } = useCurrentLocation();
  let navigate = useNavigate();
  const { lang } = useSelector(
    (state) => ({
      lang: state.changeLang.language.nav,
    }),
    shallowEqual
  );
  const breadcrumbs = [
    {
      id: 0,
      name: "ME-QR",
      pathname: "/",
      isActive: false
    },
    {
      id: 1,
      name:  lang.desktop[13],
      pathname: "/",
      isActive: false
    },
    {
      id: 3,
      name:  lang.desktop[12],
      pathname: "/qr",
      isActive: true
    }
  ];

  const handleBack = () => {
    const savedType = localStorage.getItem("generatorType");

    if (savedType) {
      navigate(`/${savedType}`);
      localStorage.removeItem("generatorType");
    } else {
      if (entryLocationEdit) {
        window.location.href = `${locale !== "en" ? `/${locale}` : ""}/entry/`;
      } else {
        navigate("/templates");
      }
    }
  };


  const [pageId, setPageId] = useState(null);
  const [iframeUrl, setIframeUrl] = useState('');


  useEffect(() => {
    const currentUrl = window.location.href;
    const match = currentUrl.match(/\/(\d+)(\/|$)/);
    if (match) {
      const id = match[1];
      setPageId(id);
    }
  }, []);

  useEffect(() => {
    const fetchData = async (pageId) => {
      try {
        const response = await axios.get(`/entry/constructor/get/${pageId}`);
        const data = response.data;
        setIframeUrl(data.iframe);
      } catch (error) {
        if (error.response) {
          if (error.response.status === 401) {
            window.location.href = `${locale !== "en" ? `/${locale}` : ""}/login?targetBack=/qr-code-generator/constructor/${pageId}/edit`;
          } else if (error.response.status === 403) {
            window.location.href = `${locale !== "en" ? `/${locale}` : ""}/error/403`;
          } else {

            console.error("Error:", error);
          }
        }
      }
    };
    if (pageId) {
      fetchData(pageId);
    }
  }, [pageId]);

  useEffect(() => {
    const handleMessage = async (event) => {
      const { type } = event.data;
      if (type === "PAGE_EDIT" && !isPageEdited && pageId && !isRequestUpdateTimeProgress.current) {
        isRequestUpdateTimeProgress.current = true;
        const formData = new FormData();
        formData.append("_locale", locale);
        try {
          await axios.post(`/entry/${pageId}/update-time`, formData);
          setIsPageEdited(true);
        } catch (error) {
          console.error("Error:", error);
        } finally {
          isRequestUpdateTimeProgress.current = false;
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [isPageEdited, pageId]);

  const locale = useSelector((state) => state.changeLang.change);
  const goToSecondStep = () => {
    if (pageId) {
      const localePrefix = locale !== "en" ? `/${locale}` : "";
      window.location.href = `${localePrefix}/entry/${pageId}`;
    }
  };
  return (
    <>
      <Container className='px-0 px-md-3 me-page-frame' >
        <div className="pt-3 mb-3 d-none d-md-block">
          <Breadcrumbs breadcrumbs={breadcrumbs} />
        </div>
        <Row className="align-items-center justify-content-between d-none d-md-flex mb-4">
          <Col xs={3} lg={2}>
            <Button
              variant="outline-primary"
              className="text-capitalize w-75 fs-7 py-2 text-nowrap btn-back"
              onClick={handleBack}
            >
              <Arrow />{" "}
              <span>{lang.desktop[0]}</span>
            </Button>
          </Col>
          <Col xs={6} md={4} className="text-center">
            <p className="fw-bold mb-2 fs-md-5  fs-7">
              {lang.desktop[12]}
            </p>
            <ProgressBar animated className="progress-height">
              <ProgressBar variant="primary" now={50} />
              <ProgressBar
                variant="light-primary"
                now={50}
              />
            </ProgressBar>
          </Col>
          <Col xs={6} md={3} lg={2}>
            <div className="">
              <button className="btn btn-primary fs-7 py-2 text-nowrap fw-bold w-100"
                      onClick={goToSecondStep}>{lang.desktop[10]}</button>
            </div>
          </Col>
        </Row>
        <div className="bg-white" style={{height: '85%'}}>
          <ConstructorCol>
            <div className="d-flex justify-content-center h-100">
              {iframeUrl && (
                <iframe
                  title="Embedded Content"
                  allow="clipboard-read; clipboard-write"
                  src={iframeUrl}
                  frameBorder="0"
                />
              )}
            </div>
          </ConstructorCol>
        </div>
      </Container>
      <div className="sticky-bottom bg-white p-3 d-flex d-md-none justify-content-between shadow-lg">
        <button className='btn btn-outline-primary px-4 fw-normal text-capitalize'
                onClick={handleBack}>{lang.desktop[0]}</button>
        <button className='btn btn-primary px-4' onClick={goToSecondStep}>{lang.desktop[11]}</button>
      </div>
    </>
  );
};
const ConstructorCol = styled.div`
    height: 100%;
    @media screen and (max-width: 767px) and (min-width: 400px) {
        height: 86vh;
    }
    @media screen and (max-width: 399px) and (min-width: 381px) {
        height: 716px;
    }
    @media screen and (max-width: 380px)and (min-width: 375px) {
        height: 538px;
    }
    @media screen and (max-width: 374px) and (min-width: 350px) {
        height: 612px;
    }

    iframe {
        width: 100%;
        height: 100%;
    }
`;

export default ConstructorPage;
